// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A map projecting the latest fire-danger warnings and bans onto Australia's states and territories.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Live fire-danger ratings map",
  id: "live-fire-danger-ratings-map",
  linkPrefix: "/interactives",
  groupsWithAccess: [], //ALL_USER_GROUPS_BUT_GUESTS,
  tags: ["Weather", "Configurable", "Map", "Data viz"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
  "https://www.smh.com.au/interactive/2020/bushfire/data-center/index.html?resizable=true&embed=true&map=firerating",
    // "https://www.smh.com.au/interactive/modules/fire-ban-rating-map/live/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "LiveFireDangerRatingsMapConfigTool" */ "app/components/tools/LiveFireDangerRatingsMapConfigTool/LiveFireDangerRatingsMapConfigTool"),
    loading: DynamicImportLoader,
    modules: ["LiveFireDangerRatingsMap"]
  })
};

export default CONFIG;
